export default __webpack_public_path__ + "static/media/reddit.497483f0.png";